
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { type CaixaLotteryType } from "@/utils/caixaLotteriesUtils";
import { type SubscriptionPlan } from "@/utils/predictionUtils";
import CaixaLotterySelector from "./CaixaLotterySelector";
import GameCountSelector from "./GameCountSelector";
import ColoredAISelector from "@/components/prediction/ColoredAISelector";

interface LoteriasHeaderProps {
  selectedLottery: CaixaLotteryType;
  onLotteryChange: (lottery: CaixaLotteryType) => void;
  selectedAI: "gemini" | "chatgpt" | "claude";
  onAIChange: (ai: "gemini" | "chatgpt" | "claude") => void;
  gameCount: number;
  onGameCountChange: (count: number) => void;
  userPlan: SubscriptionPlan;
  disabled?: boolean;
}

const LoteriasHeader: React.FC<LoteriasHeaderProps> = ({
  selectedLottery,
  onLotteryChange,
  selectedAI,
  onAIChange,
  gameCount,
  onGameCountChange,
  userPlan,
  disabled = false
}) => {
  return (
    <Card className={`mb-6 ${disabled ? "opacity-60 border-red-300" : ""}`}>
      <CardHeader>
        <CardTitle className="flex items-center justify-center gap-2">
          {disabled && <Lock className="w-5 h-5 text-red-500" />}
          Configurações
          {disabled && (
            <span className="text-sm bg-red-500 text-white px-2 py-1 rounded-full">
              PERÍODO EXPIRADO
            </span>
          )}
        </CardTitle>
        <CardDescription>
          {disabled 
            ? "Recursos bloqueados - Período de teste expirado" 
            : "Configure suas preferências para gerar palpites"
          }
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <CaixaLotterySelector 
            selectedLottery={selectedLottery}
            onLotteryChange={onLotteryChange}
            disabled={disabled}
          />
          
          <ColoredAISelector
            selectedAI={selectedAI}
            onAIChange={onAIChange}
            disabled={disabled}
          />

          <GameCountSelector
            gameCount={gameCount}
            onGameCountChange={onGameCountChange}
            userPlan={userPlan}
            disabled={disabled}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default LoteriasHeader;
